(function () {
  'use strict';

  if (window.VanemarAnalytics) return;
  var configElement = document.getElementById('vanemar-analytics-config');
  if (!configElement) return;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (error) { return; }
  if (!/^G-[A-Z0-9]+$/.test(config.measurementId || '')) return;
  if (window.Shopify && window.Shopify.designMode) return;
  // Preview interactions must not inflate production reports. A developer can
  // deliberately enable DebugView in an unpublished theme for verification.
  if (!config.debug && window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main') return;
  if (!config.debug && new URLSearchParams(window.location.search).has('preview_theme_id')) return;

  var events = new Set([
    'wizard_view', 'wizard_start', 'wizard_step_view', 'wizard_complete',
    'wizard_restart', 'wizard_add_to_cart', 'wizard_cart_error',
    'site_cta_click', 'faq_open', 'product_option_change', 'product_select',
    'site_form_view', 'site_form_start', 'site_form_submit', 'site_form_error',
    'generate_lead', 'newsletter_subscribe', 'search_results_view',
    'search_no_results', 'search_result_click', 'product_media_interaction',
    'checkout_click', 'pricing_view', 'video_start', 'video_progress', 'video_complete'
  ]);
  var numericParameters = new Set([
    'wizard_step', 'wizard_steps_total', 'wizard_run', 'duration_ms',
    'faq_index', 'option_position', 'product_id', 'variant_id', 'result_count',
    'result_index', 'media_index', 'video_percent', 'video_duration', 'video_current_time'
  ]);
  var categoricalParameters = {
    wizard_step_type: ['needs', 'question', 'result'],
    error_type: ['cart_request_failed', 'validation', 'server_response'],
    cta_type: ['wizard', 'callback', 'support', 'email', 'phone', 'shop', 'connect',
      'how_it_works', 'coverage', 'nmea', 'app_ios', 'app_android', 'fleet', 'features', 'reviews'],
    cta_location: ['header', 'footer', 'wizard', 'content'],
    form_type: ['contact', 'newsletter'],
    form_provider: ['shopify', 'hubspot'],
    item_list_id: ['search', 'collection', 'home', 'related'],
    result_type: ['product', 'page', 'article'],
    media_action: ['thumbnail', 'next', 'previous', 'zoom', 'external_play'],
    media_context: ['product'],
    video_provider: ['shopify']
  };
  var queue = [];
  var retryTimer = null;
  var wasAllowed = false;

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function isAllowed() {
    try {
      return !!(privacy() && privacy().analyticsProcessingAllowed());
    } catch (error) {
      return false;
    }
  }

  function marketingAllowed() {
    try {
      return !!(privacy() && privacy().marketingAllowed());
    } catch (error) {
      return false;
    }
  }

  // Ads conversions use the app's top-frame tag, which can read the ad click
  // cookie. Tags inside a Customer Events sandbox cannot, so they go unattributed.
  // Debug sessions never reach Ads; DebugView is a GA4-only tool.
  var conversions = { lead: config.adsLeadSendTo };
  function conversion(kind) {
    var sendTo = conversions[kind];
    if (config.debug || !/^AW-\d+\/[\w-]+$/.test(sendTo || '')) return false;
    if (!marketingAllowed() || typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', 'conversion', { send_to: sendTo });
      return true;
    } catch (error) {
      return false;
    }
  }

  function cleanUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin + url.pathname;
    } catch (error) {
      return '';
    }
  }

  function parameters(input) {
    var output = {
      send_to: config.measurementId,
      page_type: config.pageType,
      site_language: config.language,
      page_location: cleanUrl(window.location.href),
      page_referrer: document.referrer ? cleanUrl(document.referrer) : ''
    };
    // A search page's document title can contain the visitor's raw query.
    if (config.pageType === 'search') output.page_title = 'Vanemar | Site search';
    // Explicit allowlists prevent form answers, contact details, error messages
    // and URL query strings from being accidentally added to these events.
    Object.keys(input || {}).forEach(function (key) {
      var value = input[key];
      if (numericParameters.has(key) && typeof value === 'number' && Number.isFinite(value) && value >= 0) {
        output[key] = Math.round(value);
      } else if (categoricalParameters[key] && categoricalParameters[key].indexOf(value) !== -1) {
        output[key] = value;
      } else if (key === 'product_handle' && typeof value === 'string' && /^[a-z0-9-]{1,120}$/.test(value)) {
        // Public catalogue URL slugs only; never free text from form fields.
        output[key] = value;
      }
    });
    if (config.debug) output.debug_mode = true;
    return output;
  }

  function flush() {
    window.clearTimeout(retryTimer);
    retryTimer = null;
    if (!isAllowed()) {
      queue = [];
      return;
    }
    queue = queue.filter(function (entry) { return Date.now() - entry.created < 15000; });
    if (typeof window.gtag === 'function') {
      while (queue.length && isAllowed()) {
        var entry = queue.shift();
        try {
          window.gtag('event', entry.name, entry.params);
        } catch (error) {
          // Measurement failure must never interrupt shopping or navigation.
          if (config.debug) console.warn('[Vanemar Analytics] Event could not be queued:', entry.name);
        }
      }
    }
    if (queue.length) retryTimer = window.setTimeout(flush, 250);
  }

  function track(name, input) {
    // Nothing is recorded or buffered before analytics permission is available.
    if (!events.has(name) || !isAllowed()) return false;
    if (queue.length >= 40) return false;
    queue.push({ name: name, params: parameters(input), created: Date.now() });
    flush();
    return true;
  }

  function consentChanged() {
    var allowed = isAllowed();
    flush();
    if (allowed && !wasAllowed) document.dispatchEvent(new CustomEvent('vanemar:analytics-ready'));
    wasAllowed = allowed;
  }

  window.VanemarAnalytics = { track: track, isAllowed: isAllowed, conversion: conversion, pageType: config.pageType };
  document.addEventListener('visitorConsentCollected', consentChanged);
  consentChanged();
  if (!privacy() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) consentChanged();
    });
  }

  function locationOf(element) {
    if (element.closest('[data-vmw]')) return 'wizard';
    if (element.closest('footer, [id$="__footer"], [id*="shopify-section-footer"]')) return 'footer';
    if (element.closest('header, [id*="shopify-section-header"]')) return 'header';
    return 'content';
  }

  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    var link = event.target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (error) { return; }
    var type;
    if (url.origin === window.location.origin && url.hash === '#product-wizard') type = 'wizard';
    else if (url.origin === window.location.origin && /\/pages\/(request-a-callback|vm-contact|contact)\/?$/.test(url.pathname)) type = 'callback';
    else if (url.hostname === 'support.vanemar.com') type = 'support';
    else if (url.protocol === 'mailto:') type = 'email';
    else if (url.protocol === 'tel:') type = 'phone';
    else if (url.hostname === 'apps.apple.com') type = 'app_ios';
    else if (url.hostname === 'play.google.com') type = 'app_android';
    else if (url.origin === window.location.origin && /\/collections\/[^/]+\/?$/.test(url.pathname)) type = 'shop';
    else if (url.origin === window.location.origin) {
      var page = url.pathname.match(/\/pages\/(vm-connect|vanemar-connect|how-it-works|coverage|nmea-integration|fleet|features|reviews)\/?$/);
      if (page) type = { 'vm-connect': 'connect', 'vanemar-connect': 'connect', 'how-it-works': 'how_it_works',
        coverage: 'coverage', 'nmea-integration': 'nmea', fleet: 'fleet', features: 'features', reviews: 'reviews' }[page[1]];
    }
    if (type) track('site_cta_click', { cta_type: type, cta_location: locationOf(link) });
  });

  // The initial `open` attribute also queues a toggle event. Seed the previous
  // state from the parsed HTML so that first paint is not counted as a click.
  var faqStates = new WeakMap();
  document.querySelectorAll('details.faq-item').forEach(function (details) {
    faqStates.set(details, details.open);
  });
  // toggle does not bubble; capture covers pointer and keyboard activation.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!(details instanceof Element) || !details.matches('details.faq-item')) return;
    var previouslyOpen = faqStates.get(details);
    faqStates.set(details, details.open);
    if (previouslyOpen !== false || !details.open) return;
    var list = details.closest('[id^="faq-list-"]');
    if (!list) return;
    track('faq_open', { faq_index: Array.from(list.querySelectorAll('details.faq-item')).indexOf(details) + 1 });
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    if (!event.target.matches('[data-pdp-option], [data-pdp-variant-select]')) return;
    track('product_option_change', { option_position: Number(event.target.dataset.position) || 0 });
  });
})();
